import { Component, OnInit, ViewChild } from '@angular/core';



import { InternalUser, Roles, Agency } from '@adminmodel/admin';
import { SelectItem } from 'primeng/api';
import { AdminService } from '@adminservice/admin.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import { ValueTransformer } from '@angular/compiler/src/util';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { Angular2Csv } from 'angular2-csv';
import { authManager } from '@authmanager/authManager';
import { Table } from 'primeng/table';
import { Router, ActivatedRoute } from '@angular/router';
import { AgencyService } from './Service/agency.service';
import { AdminAgency } from './Model/agency';

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.css'],
  providers: [ConfirmationService, AgencyService]
})
export class AgencyComponent implements OnInit {
  // Arvind Add Agency
  @ViewChild('dtInternal') private _internalUsersTable: Table;

  @ViewChild('dtExternal') private _externalUsersTable: Table;
  userDetails: any = [];
  // invalidSSO: boolean;
  invalidAgencyID: boolean;
  invaliStationID:boolean;
  isInEmailExist: boolean;
  invalidFileFormat: boolean;
  saveMsg: boolean;
  invalidExEditAgency: boolean;
  invalidInEditEmail: boolean;
  invalidExEditEmail: boolean;
  invalidExEditFirstName: boolean;
  invalidInEditFirstName: boolean;
  duplicatestationName:boolean;
  invalidInEditLastName: boolean;
  invalidExEditLastName: boolean;
  invalidSSOAddNewIn: boolean;
  duplicateSSOEditIN: boolean;
  duplicateEmailEditIN: boolean;
  Agencyresult: any;
  Agencynameresult: any;

  StationNameresult: any;
  duplicateEmailEditEx: boolean;
  msgs: any = [];
  ExMsgs: any = [];
  ssoMsg: any = [];
  emailMsg: any = [];
  firstNameMsg: any = [];
  lastNameMsg: any = [];
  agencyMsg: any = [];
  roleMsg: any = [];
  ValidateExFirstName: boolean;
  ValidateExLastName: boolean;
  ValidatestationGroupName: boolean;
  ValidateExEmail: boolean;
  ValidateExAgency: boolean;
  validateSSO: boolean;
  ValidateAgencyName: boolean;
  ValidateFirstName: boolean;
  ValidateEmail: boolean;
  ValidateLastName: boolean;
  ValidateAgency: boolean;
  ValidateRole: boolean;
  duplicateAgency: boolean;
  duplicateAdvertiser: boolean;
  // set if the SSO is dupliacted
  disableSubmitbtn: boolean; // set if the SSO is dupliacted

  internalUser: any = [];
  externalUser: any[] = [];
  // // Arvind Add Agency
  // Advertiser: any = [];
  AdminAgency: any = [];
  Station: any = [];
  // // End Arvind Add Agency
  // LogUserDetails: any = [];
  // UserLogStatus: any = [];

  updatedINDetails: any = {};
  //updatedExDetails: any = {};
  updatedStationDetails: any = {};
  deletedAgencyDetails: any = {};
  deletedINuserDetails: any = {};
  deletedstationRow: any = {};

  externalUserType: string;
  internalUserType: string;
  IsActive: number;

  selectedInternalUser;
  selectedExternalUsers;

  ShowInternalUser: boolean;
  ShowExternalUser: boolean;

  saveRow: boolean;
  cancelRow: boolean;

  saveExternalRow: boolean;
  cancelExternalRow: boolean;

  showAddagencyRow: boolean;
  //ShowExternalUser: boolean;
  showAddExternalUserRow: boolean;

  // // Arvind Add Agency
  // ShowAddAgency: boolean;
  // //End Arvind Add Agency 

  showSubmitbtn: boolean;
  userRoles: Roles[];
  selectedRole: Roles;
  agency: Agency[];
  agencyFilter: any[];
  selectedInAgency: Agency;
  selectedExAgency: Agency;
  //selectedExstation: Station;
  emailPattern: any;
  internalEmailPattern: string;
  namePattern: any;
  ssoPattern: any;

  //agencyID:agencyID[];
  agencyID: string;
  agencyName: string;
  beforIN: any = {};
  beforINEdit: any = {};
  beforEx: any = {};
  beforExEdit: any = {};
  postStatus: any;
  // SSOresult: any;
  //Arvind agency
  // Agencyresult: any;
  Stationresult: any;

  //End arvind

  SSOduplicateStatus: any;
  INduplicateEmailonEdit: any;
  ExduplicateEmailonEditStatus: any;

  disableINeditBtn: boolean;
  disableINdeleteBtn: boolean;
  disableExEditBtn: boolean;
  disableExDeleteBtn: boolean;
  disableINUpdateBtn: boolean;
  disableExUpdateBtn: boolean;

  displayBulkUploadPopUp: boolean;
  fname: any;
  value: any;
  jsonFile: any;
  temp: any;
  BulkData: any = {};
  fileDataError: boolean;

  public newInternalUser: any = {};
  public newRole: any = {};
  public newAgency: any = {};
  public newExAgency: any = {};
  public newExtenalUser: any = {};

  LognewUser: any = {};
  UserLog: string;
  require: any;
  LnewUser: any = {};
  isAddInternal: boolean;
  // Arvind Add Agency
  isAddAgency: boolean;
  //End Arvind Add Agency
  // filters
  enableInternalUsersFilter: boolean;
  enableExternalUsersFilter: boolean;

  hideinternal: boolean;
  bulkUploadEmailPattern: any;
  invalidData: boolean;
  MultiAgencyExist: boolean;
  AddMultiAgencyExist: boolean;
  duplicateExternalAgency: string;
  MultipleAgeccyID: string;
  UserId: string;

  public paddingCells: any = {
    background: '#ff0000',
    textAlign: 'center'
  };


  constructor(private adminService: AdminService, private confirmationService: ConfirmationService,
    private http: HttpClient, private AuthManager: authManager, private router: Router, private agencyservice: AgencyService) {
    this.invalidFileFormat = true;
    this.saveMsg = true;
    // this.disableExUploadBtn = false;
    // this.isExEmailExist = true;
    // this.isInEmailExist = true;
    this.validateSSO = true;
    this.ValidateFirstName = true;
    this.ValidateAgencyName = true;
    this.ValidateEmail = true;
    this.ValidateLastName = true;
    this.ValidateAgency = true;
    this.ValidateRole = true;
    this.validateSSO = true;
    this.invalidAgencyID = true;
    this.invaliStationID= true;
    this.invalidSSOAddNewIn = true;
    this.duplicateSSOEditIN = true;
    this.duplicateEmailEditIN = true;
    this.duplicateEmailEditEx = true;
    this.invalidInEditEmail = true;
    this.invalidInEditFirstName = true;
    this.duplicatestationName = true;
    this.invalidInEditLastName = true;
    this.invalidExEditEmail = true;
    this.invalidExEditAgency = true;
    this.invalidExEditFirstName = true;
    this.invalidExEditLastName = true;
    this.duplicateAgency = true;
    this.duplicateAdvertiser = true;
    this.disableSubmitbtn = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidatestationGroupName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;

    this.externalUserType = 'E';
    this.internalUserType = 'I';
    this.IsActive = 1;
    this.saveRow = false;
    this.cancelRow = false;
    this.saveExternalRow = false;
    this.cancelExternalRow = false;

    this.showAddagencyRow = false;
    this.showAddExternalUserRow = false;
    this.showSubmitbtn = false;

    this.disableINeditBtn = false;
    this.disableINdeleteBtn = false;
    this.disableExEditBtn = false;
    this.disableExDeleteBtn = false;
    this.disableINUpdateBtn = false;
    this.disableExUpdateBtn = false;
    this.fileDataError = false;
    this.enableInternalUsersFilter = false;
    this.enableExternalUsersFilter = false;
    this.hideinternal = false;
    this.invalidData = false;
    this.MultiAgencyExist = false;
    this.AddMultiAgencyExist = false;

    this.displayBulkUploadPopUp = false;



    // Service call to get the user roles

    this.adminService.getUserRoles().subscribe(
      p => this.userRoles = p,
    );
    // Service call to get the Agency List
    this.agencyservice.getAgencyList()
      .subscribe(resAgencyData => this.AdminAgency = resAgencyData);

    this.agencyservice.getStationList()
      .subscribe(resAgencyData => this.Station = resAgencyData);

  }

  ngOnInit() {
    if(window.location.href.indexOf("ssoid")> -1)
    {
      var ssoid = window.location.search.substring(location.search.indexOf("ssoid=") + 6);
      sessionStorage.setItem("ssoid",ssoid);
      console.log(ssoid);
      window.location.href="/"; // homepage url
    }
    this.MultiAgencyExist = false;
    if (Number(this.AuthManager.dynSSOId) > 0 && Number(sessionStorage.getItem('userid')) > 0) {
      // this.saveIP();
    }   // Method to store logged in user information
    if (sessionStorage.getItem('userRoleId') === '2') {
      this.hideinternal = true; // hiding the refund tab for admin
      let divToChange = document.getElementById('id2');
      divToChange.className = 'active';
      let oneA = document.getElementById('1a');
      oneA.className = 'tab-pane';
      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane active';
      this.ShowInternalUser = false;
      this.ShowExternalUser = true;

      this.LoadExternalUsers();

    } else {
      this.hideinternal = false;
      let divToChange = document.getElementById('id1');
      divToChange.className = 'active';

      let oneA = document.getElementById('1a');
      oneA.className = 'tab-pane active';

      let twoA = document.getElementById('2a');
      twoA.className = 'tab-pane';

      this.ShowInternalUser = true;
      this.ShowExternalUser = false;
      this.isAddInternal = false;

      // Arvind Add Agency
      this.isAddAgency = false;
      //End Arvind Add Agency

      this.LoadAgencyList();
      this.LoadExternalUsers();
    }
  }
  // service call to get the Agency list details
  LoadAgencyList() {

    this.agencyservice.getAgencyList().subscribe(
      p => { this.AdminAgency = p; }
    );
    console.log(this.AdminAgency);
  }
  // service call to get the stations Details
  LoadExternalUsers() {
    //debugger;
    this.agencyservice.getStationList()
      .subscribe(resExternalUserData => this.Station = resExternalUserData);
    console.log(this.externalUser);
    console.log(this.selectedExAgency);
  }
  // Methods to switch between Internal User and External User Tab Starts
  showInternalUser(dtExternal, ExternalUserTableSearch) {

    // To clear the external users global filter
    dtExternal.reset();
    ExternalUserTableSearch.value = '';

    this.ShowInternalUser = true;
    this.ShowExternalUser = false;
    this.showAddExternalUserRow = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidatestationGroupName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
  }
  showExternalUser(dtInternal, InternalUserTableSearch) {

    // To clear the internal users global filter
    dtInternal.reset();
    InternalUserTableSearch.value = '';

    this.ShowExternalUser = true;
    this.ShowInternalUser = false;
    this.showAddagencyRow = false;
    this.validateSSO = true;
    this.invalidSSOAddNewIn = true;
    this.invalidAgencyID = true;
    this.invaliStationID= true;
    this.ValidateAgency = true;
    this.ValidateAgencyName = true;
    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateRole = true;
    this.duplicateAgency = true;
    this.ValidateEmail = true;
  }
  // Ends
  //Arvind Agency
  // Method to show Add Agency Form
  showAddagencyArea() {
    // debugger;
    this.isAddInternal = false;
    this.showAddagencyRow = true;
    for (let item of this.AdminAgency) {
      if (item.isEditable) {
        item.isEditable = false;
        this.disableINeditBtn = false;
        this.disableINdeleteBtn = false;
      }
    }
  }

  // // End Arvind Add agency.


  // Method to show Add Advertiser by using old method name only 
  showAddStationArea() {
   // debugger;
    this.showAddExternalUserRow = true;
    for (let item of this.Station) {
      if (item.isEditable) {
        item.isEditable = false;
        this.disableExEditBtn = false;
        this.disableExDeleteBtn = false;
      }
    }

  }
  // Method to close the Add Internal User Row
  showAddInternalUserRowClose() {
    this.isAddInternal = false;

    this.isInEmailExist = true;
    this.showAddagencyRow = false;
    this.validateSSO = true;
    this.invalidSSOAddNewIn = true;
    this.ValidateEmail = true;

    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateAgency = true;
    this.ValidateRole = true;
    this.duplicateAgency = true;
    this.duplicateAdvertiser = true;
  }
  // Method to close the Add External User Row
  showAddExternalUserRowClose() {
    //debugger;
    //  this.isExEmailExist = true;
    this.showAddExternalUserRow = false;
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidatestationGroupName = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
  }

  // Internal - Edit row code starts here
  onRowEditSelect(event, myForm) {
   // debugger;

    this.showAddagencyRow = false; // hiding the add new IN user on edit
    // hiding all the validation messages of add new IN users.
    this.invalidSSOAddNewIn = true;
    this.duplicateAgency = true;
    this.validateSSO = true;
    this.ValidateAgencyName = true;
    this.ValidateFirstName = true;
    this.ValidateLastName = true;
    this.ValidateEmail = true;
    this.isInEmailExist = true;
    this.ValidateRole = true;
    this.restForm(myForm);

    // this.currentSSO = event.sso;
    // this.currentEmail = event.email;
    this.selectedRole = event.roles;
    this.selectedInAgency = event.agency;
    this.beforIN = JSON.parse(JSON.stringify(event));
    this.beforINEdit = JSON.parse(JSON.stringify(this.internalUser)); // storing current IN user
    this.disableINeditBtn = true; // disable  the edit btn on click
    this.disableINdeleteBtn = true;
    console.log(event);
    this.CloseAllEditable();
    event.isEditable = true;
    if (event.isEditable === true) {
      this.saveRow = true;
      this.cancelRow = true;
    }
  }
  CloseAllEditable() {

    for (let item of this.internalUser) {
      if (item.isEditable) {
        item.isEditable = false;
      }
    }
  }
  internalUsersFilterToggle(event) {

    this.enableInternalUsersFilter === false ? this.enableInternalUsersFilter = true : this.enableInternalUsersFilter = false;

    if (!this.enableInternalUsersFilter) {
      this._internalUsersTable.reset();
    }

  }

  externalUsersFilterToggle(event) {

    this.enableExternalUsersFilter === false ? this.enableExternalUsersFilter = true : this.enableExternalUsersFilter = false;
    if (!this.enableExternalUsersFilter) {
      this._externalUsersTable.reset();
    }
  }
  onCancelRowClick(row) {
    this.internalUser = this.beforINEdit;
    this.disableINeditBtn = false; // enable  the edit btn on cancel click
    this.disableINdeleteBtn = false; // enable the delete button on cancel click
    this.disableINUpdateBtn = false; // enable  the update btn on cancel click
    this.msgs = [];
    this.invalidAgencyID = true;
    this.invaliStationID = true;
    this.duplicateSSOEditIN = true;
    this.duplicateEmailEditIN = true;
    this.invalidInEditEmail = true;
    this.invalidInEditFirstName = true;
    this.duplicatestationName = true;
    this.invalidInEditLastName = true;
    row.isEditable = false;
    this.saveRow = false;
    this.cancelRow = false;
  }
  // Internal - Edit row code ends here

  // onRowExternalEditSelect(event, myExternalUserForm) {
  onRowStationEditSelect(event, myStationForm) {
    console.log(event);

    this.showAddExternalUserRow = false; // hiding the add new Ex user on edit
    // hiding all the validation messages of add new Ex users.
    this.ValidateExFirstName = true;
    this.ValidateExLastName = true;
    this.ValidatestationGroupName = true;
    //this.isExEmailExist = true;
    this.ValidateExEmail = true;
    this.ValidateExAgency = true;
    this.restForm(myStationForm);

    //  this.currentExEmail = event.email;
    this.selectedExAgency = event.agency;
    this.beforEx = JSON.parse(JSON.stringify(event));
    this.beforExEdit = JSON.parse(JSON.stringify(this.externalUser)); // storing current IN user
    this.disableExEditBtn = true; // disable  the edit btn on click
    this.disableExDeleteBtn = true; // disable  the delete btn on click
    this.CloseAllExternalEditable();
    event.isEditable = true;
    if (event.isEditable === true) {
      this.saveExternalRow = true;
      this.cancelExternalRow = true;
    }
  }
  CloseAllExternalEditable() {

    for (let item of this.externalUser) {
      if (item.isEditable) {
        item.isEditable = false;
      }
    }
  }
  onCancelExternalRowClick(row) {

    this.externalUser = this.beforExEdit;
    this.disableExEditBtn = false; // enable  the edit btn on cancel click
    this.disableExUpdateBtn = false; // enable  the update btn on cancel click
    this.disableExDeleteBtn = false; // enable  the delete btn on cancel click
    this.ExMsgs = [];
    row.isEditable = false;
    this.saveExternalRow = false;
    this.invalidExEditEmail = true;
    this.invalidExEditFirstName = true;
    this.invalidExEditLastName = true;
    this.duplicateEmailEditEx = true;
    this.invalidExEditAgency = true;
    this.cancelExternalRow = false;
    this.MultiAgencyExist = false;

  }

  onExternalUserBulkUpload() {

    this.BulkData = this.jsonFile;
    this.saveMsg = true;
    if (this.BulkData == null) {
      this.invalidFileFormat = false;
    } else {
      // this.BulkData = eval(this.BulkData);
      for (let item in this.BulkData) {
        if (this.BulkData.hasOwnProperty(item)) {
          this.BulkData[item].Usertype = this.externalUserType;
          this.BulkData[item].IsActive = this.IsActive;
          this.BulkData[item].CreatedDate = new Date();
          this.BulkData[item].CreatedBy = this.AuthManager.dynSSOId;
          this.BulkData[item].UserAgencyID = this.BulkData[item].UserAgencyID;
        }
      }
      this.adminService.AddMultipleExternalUsers(this.BulkData)
        .subscribe((status) => {
          this.postStatus = status;

          this.saveMsg = false;
          this.LoadExternalUsers();
          this.jsonFile = null;
        });
    }
  }


  // method to convert csv data into JSON

  HeaderCheckBoxToggle(SelctedExUsers) {
    if (SelctedExUsers.length > 0) {
      this.showSubmitbtn = true;
    } else {
      this.showSubmitbtn = false;
    }
  }
  // Method to call IDM API for SSO creation
  externalUserSSOTrigger(data) {

    this.selectedExternalUsers = data;
  }

  // Method to Add agency

  onAddNewAgencySubmit(myForm) {
   // debugger;

    //this.checkInFirstNameCheck(this.value);
    let agencyID = myForm.controls.agencyID.value;
    let agencyName = myForm.controls.agencyName.value;

    this.agencyservice.internalAgencySearch(agencyID)
      .subscribe((status) => {
        this.Agencyresult = status
        console.log(this.Agencyresult);

        if (this.Agencyresult === 'F') {
          this.duplicateAgency = false;
          this.validateSSO = true;
        }
        if (this.Agencyresult === 'P') {
          this.duplicateAgency = true;

        }
      });
    //debugger;
    this.agencyservice.internalAgencynameSearch(agencyName)
      .subscribe((status) => {
        this.Agencynameresult = status
        console.log(this.Agencynameresult);
        if (this.Agencynameresult === 'IE') {
          this.ValidateAgencyName = false;
          //this.validateSSO = true;
        }
        if (this.Agencynameresult === 'P') {
          this.ValidateAgencyName = true;
          // let agencyName = myForm.controls.agencyName.value;

          this.Addagencinew(agencyID, agencyName, myForm)
          this.showAddagencyRow = false;

        }
      });
  }

  // Method to reset the Add Internal/External form controls
  restForm(formData) {

    for (let name in formData.controls) {
      if (formData.controls.hasOwnProperty(name)) {
        formData.controls[name].reset();
      }
    }
  }

  onAddNewStationSubmit(myStationForm) {
   // debugger;
    let stationID = myStationForm.controls.stationID.value;
    let stationName = myStationForm.controls.stationName.value;
    this.agencyservice.internalStationSearch(stationID)
      .subscribe((status) => {
        this.Stationresult = status
        console.log(this.Stationresult);

        if (this.Stationresult === 'F') {
          this.duplicateAdvertiser = false;
          this.validateSSO = true;
        }
        if (this.Stationresult === 'P') {
          this.duplicateAdvertiser = true;
          //this.ValidateExLastName = true;
          this.ValidatestationGroupName = true;
          let stationName = myStationForm.controls.stationName.value;
          let stationGroupName = myStationForm.controls.stationGroupName.value;

        }
      });
    this.agencyservice.internalstationnameSearch(stationName)
      .subscribe((status) => {
        this.StationNameresult = status
        console.log(this.StationNameresult);

        if (this.StationNameresult === 'IE') {
          this.ValidateExLastName = false;
          this.ValidatestationGroupName = true;
        }
        if (this.StationNameresult === 'P') {
          this.ValidateExLastName = true;
          this.ValidatestationGroupName = true;
          this.duplicateAdvertiser = true;
          let stationName = myStationForm.controls.stationName.value;
          let stationGroupName = myStationForm.controls.stationGroupName.value;
          this.Addstationnew(stationID, stationName, stationGroupName, myStationForm)
          this.showAddExternalUserRow = false;
        }
      });
  }

  Addstationnew(stationID, stationName, stationGroupName, myStationForm) {
   // debugger;
    this.agencyservice.postNewStationDetails(stationID, stationName, stationGroupName)
      .subscribe((status) => {
        //debugger;
        this.Stationresult = status;
        console.log(this.Stationresult);
        this.LoadExternalUsers();

      })
    // this.restForm(myForm);
  }
  // Method to add new station.
  onAddNewExternalUserSubmit(myStationForm) {
   //debugger;
    let stationID = myStationForm.controls.stationID.value;
    let stationName = myStationForm.controls.stationName.value;
    let stationGroupName = myStationForm.controls.stationGroupName.value;
    this.Addstationnew(stationID, stationName, stationGroupName, myStationForm);
    this.showAddExternalUserRow = false;

  }
  //Addagencinew(agencyID,agencyName)
  Addagencinew(agencyID, agencyName, myForm) {
   // debugger;
    this.agencyservice.postNewAgencyDetails(agencyID, agencyName)
      .subscribe((status) => {
        //debugger;
        this.Agencyresult = status;
        console.log(this.Agencyresult);
        //   if(agencyID === '' || agencyName === '' || agencyID == null || agencyName == null)
        // {
        //   this.ValidateFirstName = false;
        //   this.validateSSO = false;
        // }
        this.LoadAgencyList();


      })

  }


  // Method to update Agency Row
  onUpdateAgencyRowClick(updatedInUserRow) {

    //debugger;


    this.updatedINDetails = {};

    let bdata = this.beforIN;
    delete bdata.isEditable;
    delete updatedInUserRow.isEditable;
    //updatedInUserRow.agencyid= updatedInUserRow.agencyID;

    {    // this.msgs = [];
      // this.invalidSSO = true;
      // this.invalidInEditFirstName = true;
      // this.invalidInEditLastName = true;


      this.updatedINDetails.agencyID = <number>(updatedInUserRow.agencyID);
      this.updatedINDetails.agencyName = <string>(updatedInUserRow.agencyName);
      this.EditupdateAgencyDetails(this.updatedINDetails);

    }
    // updatedInUserRow.isEditable = false;
    this.disableINeditBtn = false;
    this.disableINdeleteBtn = false;
  }




  //Update station 

  onUpdateStationRowClick(updatedStationRow) {
  //  debugger;
    this.updatedStationDetails = {};
    // if (updatedExUserRow.agency === '') {
    //   delete updatedExUserRow.agency;
    // }

    let bdata = this.beforEx;
    delete bdata.isEditable;
    delete updatedStationRow.isEditable;
    updatedStationRow.station = this.Station;
    {

      this.updatedStationDetails.stationID = <number>(updatedStationRow.stationID);
      this.updatedStationDetails.stationName = <string>(updatedStationRow.stationName);
      this.updatedStationDetails.stationGroupName = <string>(updatedStationRow.stationGroupName);

      this.EditupdateStationDetails(this.updatedStationDetails);
    }
    updatedStationRow.isEditable = false;
    this.disableExEditBtn = false;
    this.disableExDeleteBtn = false;

  }

  updateAgencyDetails(updatedAgencyDetails) {
    //debugger;
    // updatedUserRow.UpdatedDate = new Date();
    //  updatedUserRow.UpdatedBy = this.AuthManager.dynSSOId; // 500021256; //need to change
    this.agencyservice.updateAgencyDetails(updatedAgencyDetails.agencyID, updatedAgencyDetails.agencyName)
      .subscribe((status) => {
        this.postStatus = status;
        console.log(this.postStatus);

        console.log('Saved');
        this.LoadAgencyList();
        this.LoadExternalUsers();


      });
  }

  updatestationDetails(updatedStationDetails) {
    //debugger;
    // updatedUserRow.UpdatedDate = new Date();
    //  updatedUserRow.UpdatedBy = this.AuthManager.dynSSOId; // 500021256; //need to change
    //this.agencyservice.updatestationDetails(updatedStationDetails.stationID,updatedStationDetails.stationName,updatedStationDetails.stationGroupName)
    this.agencyservice.updatestationDetails(updatedStationDetails)

      .subscribe((status) => {
        this.postStatus = status;
        console.log(this.postStatus);

        console.log('Saved');
        this.LoadAgencyList();
        this.LoadExternalUsers();


      });
  }

  EditupdateAgencyDetails(updateAgencyRow) {
    //debugger;
    // Adding on 2/4/2019 for validation check in edit row.
    let agencyID = updateAgencyRow.agencyID;
    this.agencyservice.internalAgencySearch(agencyID)
      .subscribe((status) => {
        this.Agencyresult = status
        console.log(this.Agencyresult);

        if (this.Agencyresult === 'F') {
          //debugger;
          this.duplicateAgency = false;
          this.validateSSO = true;
        }
        if (this.Agencyresult === 'P') {

          this.duplicateAgency = true;
          let agencyName = updateAgencyRow.agencyName.value;


          //  this.Addagencinew(agencyID,agencyName, myForm)
          // this.saveRow = false;
        }
      });
   // debugger;
    // // return this.Agencyresult;
    // End Arvind for validation check in edit row.

    this.agencyservice.updateAgencyDetails(updateAgencyRow.agencyID, updateAgencyRow.agencyName)
      .subscribe((status) => {
        this.postStatus = status;
        console.log(this.postStatus);

        console.log('Saved');

      });
  }

  // Method to update station User details
  EditupdateStationDetails(updatedUserRow) {
    // debugger;
    // updatedUserRow.UpdatedDate = new Date();
    // updatedUserRow.UpdatedBy = this.AuthManager.dynSSOId; // 500021256; //need to change
    // 
    this.agencyservice.updatestationDetails(updatedUserRow)
      .subscribe((status) => {
        this.postStatus = status;
        console.log(this.postStatus);

        console.log('Saved');

      });
  }
  //
  valuechange(newValue) {

    let newSSO = [];

    newSSO = newValue;
    let InternDetails: any[] = [];
    if (newSSO.length === 9 && newSSO !== [] && newSSO != null) {
      console.log(newSSO);
    }

  }
  // Method to check whether the input fields of Agency 
  checkInFields(value) {
  //  debugger;
    if (value.agencyID === '' || value.agencyName === ''
    ) {
      this.ValidateAgencyName = true;
      this.invalidInEditFirstName = true;
    }

  }

  // Method to check the AgencyIDField Field
  checkAgencyIDField(value) {
    //debugger;
    let agencyID = value.agencyID;
    this.agencyservice.internalAgencySearch(agencyID)
      .subscribe((status) => {
        this.Agencyresult = status
        console.log(this.Agencyresult);

        if (this.Agencyresult === 'F') {
          // this.duplicateAgency = false;
          // this.validateSSO = true;
          this.duplicateSSOEditIN = false;
        }
        if (this.Agencyresult === 'P') {
          // this.duplicateAgency = true;
          this.duplicateSSOEditIN = true;
        }
        // Arvind
        if (value.agencyID === '') {

          this.disableINUpdateBtn = true;
          this.invalidAgencyID = false;
          this.duplicateSSOEditIN = true;
        }
        if (value.agencyID !== '') {
          if (value.agencyID.length !== 8) {
            this.disableINUpdateBtn = true;
            this.invalidAgencyID = false;
            this.duplicateSSOEditIN = true;

          }
          else {
            this.disableINUpdateBtn = false;
          }
        }
      });
  }

  // // Method to delete Agency users
  // Method to delete Agency
  onRowINdeleteSelect(deletedInUserRow) {
    //debugger;
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {

        this.deletedAgencyDetails.agencyID = deletedInUserRow.agencyID;
        this.deletedAgencyDetails.agencyName = deletedInUserRow.agencyName;
        this.updateAgencyDetails(this.deletedAgencyDetails);
      }
    });

  }
  // Method to delete station 

  onRowStationDelete(deletedstationRow) {
    //debugger;
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'fa fa-trash',
      accept: () => {
        this.deletedINuserDetails.stationID = deletedstationRow.stationID;
        this.deletedINuserDetails.stationName = deletedstationRow.stationName;
        this.deletedINuserDetails.stationGroupName = deletedstationRow.stationGroupName;
        this.deletedINuserDetails.station = <number>(deletedstationRow.stationID);
        this.updatestationDetails(this.deletedINuserDetails);
      }
    });

  }
  // Method to check agency name
  checkagencyNameCheck(value) {
    //debugger;
    let agencyName = value.agencyName;
    this.agencyservice.internalAgencynameSearch(agencyName)
      .subscribe((status) => {
        this.Agencynameresult = status
        console.log(this.Agencynameresult);
        if (this.Agencynameresult === 'IE') {
          this.invalidInEditFirstName = false;
          //this.validateSSO = true;
          this.disableINUpdateBtn = true;
        }
        if (this.Agencynameresult === 'P') {
          this.invalidInEditFirstName = true;
          this.disableINUpdateBtn = false;
          // let agencyName = myForm.controls.agencyName.value;

          // this.Addagencinew(agencyID,agencyName, value)
          //this.showAddagencyRow = false;

        }
      });

  }
//Method to check statio id  name on edit

checkStationIDField(value) {
 // debugger;
  let stationID= value.stationID;
  this.agencyservice.internalStationSearch(stationID)
    .subscribe((status) => {
      this.Stationresult = status
      console.log(this.Stationresult);

      if (this.Stationresult === 'F') {
       // debugger;
        this.duplicateAdvertiser = false;
        this.disableExUpdateBtn = true;
      }
      if (this.Stationresult === 'P') {
        // this.duplicateAgency = true;
        this.duplicateAdvertiser = true;
      }
      // Arvind
      if (value.stationID === '') {
       // debugger;
        this.disableExUpdateBtn = true;
        this.invaliStationID = false;
        this.duplicateAdvertiser = true;
      }
      if (value.stationID !== '') {
        if (value.stationID.length > 5) {
          this.disableExUpdateBtn = true;
          this.invaliStationID = false;
        this.duplicateAdvertiser = true;

        }
        
      }
      else {
        this.disableExUpdateBtn = false;
      }
    });
}

checkStationNameField(value) {
  //debugger;
  let stationName= value.stationName;
  this.agencyservice.internalstationnameSearch(stationName)
    .subscribe((status) => {
      this.StationNameresult = status
      console.log(this.StationNameresult);

      if (this.StationNameresult === 'IE') {
        this.duplicatestationName = false;
        //this.validateSSO = true;
        this.disableExUpdateBtn = true;
      }
      if (this.StationNameresult === 'P') {
        this.duplicatestationName = true;
        this.disableExUpdateBtn = false;
        // let agencyName = myForm.controls.agencyName.value;

        // this.Addagencinew(agencyID,agencyName, value)
        //this.showAddagencyRow = false;

      }
    });
      // Arvind
        
      }

}






// WEBPACK FOOTER //
// ./src/app/admin/agency/agency.component.ts